import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IPageMast } from "../../models/PageMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyPage } from "./EmptyPage";

const schema = yup.object({
    pageName: yup.string().required("Page Name is required*"),
    pageURL: yup.string().nullable(),
    description: yup.string().nullable()
});

interface Iprops {
    singleData: IPageMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPageMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    const saveToDB = async (body: IPageMast) => {
        const method = props.singleData.pageId ? "PUT" : "POST";
        const message = props.singleData.pageId ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Page_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success',  detail: message, life: 3000 });
            reset(EmptyPage);
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyPage);
    }

    function onSubmit(data: IPageMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Page" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Page Name" control={control} name="pageName" error={errors.pageName?.message} />
                <JVInput label="Page URL" control={control} name="pageURL" error={errors.pageURL?.message} />
                <JVInput label="Description" control={control} name="description" error={errors.description?.message} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
